import type { CloseReason, Runtime, StreamMachine } from "@baton/core";
import type { WorkspaceSession } from "./session.ts";

/**
 * The open streams and the per-workspace sessions of a runtime, apart from the stream engine so
 * sign-out (`auth/session/signOut.ts`, in the authenticated entry) can close them without loading it.
 */
export const sessions = new WeakMap<Runtime, Map<string, WorkspaceSession>>();
const machines = new WeakMap<Runtime, Set<StreamMachine>>();

/** Register an open machine so sign-out can close it; returns the unregister. */
export function trackMachine(runtime: Runtime, machine: StreamMachine): () => void {
  const open = machines.get(runtime) ?? new Set<StreamMachine>();
  machines.set(runtime, open);
  open.add(machine);
  return () => {
    open.delete(machine);
  };
}

/** Sign-out and a dismissed re-authentication: close every stream and forget every cursor; a `sign-out` the server confirmed also closes the other tabs' (2026-10-14). */
export function endWorkspaceSessions(runtime: Runtime, reason: CloseReason): void {
  for (const machine of machines.get(runtime) ?? []) machine.close(reason);
  machines.delete(runtime);
  sessions.delete(runtime);
}
